import ThumbUp from 'app/images/surveys/thumb-up.svg'
import ThumbDown from 'app/images/surveys/thumb-down.svg'

import styles from './SurveysTableResults.module.scss'


type Props = {
  positive: number
  negative: number
}

export const SurveysTableResults = ({ positive, negative }: Props) => (
  <div className={styles.root}>
    <span className={`${styles.vote} ${styles.positive}`}>
      <ThumbUp aria-label="Положительные ответы" />
      {positive.toLocaleString('ru-RU')}
    </span>
    <span className={`${styles.vote} ${styles.negative}`}>
      <ThumbDown aria-label="Отрицательные ответы" />
      {negative.toLocaleString('ru-RU')}
    </span>
  </div>
)
